// Hero parallax
const heroWrap = document.getElementById('hero-image-wrap');
window.addEventListener('scroll', () => {
  if (heroWrap && window.innerWidth > 768) {
    heroWrap.style.transform = `translateY(${window.scrollY * 0.3}px)`;
  }
}, { passive: true });

document.getElementById('hero-arrow')?.addEventListener('click', () => {
  document.querySelector('.marquee')?.scrollIntoView({ behavior: 'smooth' });
});

// Search toggle
document.getElementById('search-toggle')?.addEventListener('click', () => {
  document.getElementById('search-bar').classList.toggle('active');
  document.getElementById('mobile-nav')?.classList.remove('active');
});
document.getElementById('search-close')?.addEventListener('click', () => {
  document.getElementById('search-bar').classList.remove('active');
});

// Mobile menu toggle
document.getElementById('mobile-menu')?.addEventListener('click', () => {
  const nav = document.getElementById('mobile-nav');
  const open = nav?.classList.toggle('active');
  document.getElementById('mobile-menu').setAttribute('aria-expanded', open ? 'true' : 'false');
  if (open) document.getElementById('search-bar')?.classList.remove('active');
});

// Product card image swap on hover
document.querySelectorAll('.product-card').forEach(card => {
  const img = card.querySelector('.product-card__image');
  const img1 = card.dataset.image1;
  const img2 = card.dataset.image2;
  if (img2 && img2 !== 'null' && img2 !== img1) {
    card.addEventListener('mouseenter', () => { img.src = img2; });
    card.addEventListener('mouseleave', () => { img.src = img1; });
  }
});

// Thumbnails swap on product page
document.querySelectorAll('.product-detail__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    document.getElementById('main-product-image').src = thumb.dataset.full;
    document.querySelectorAll('.product-detail__thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// Size selector + add to cart
// Seed from the pre-selected variant so submitting without re-clicking a size works.
let selectedVariantId = document.getElementById('variant-id')?.value || null;
document.querySelectorAll('.size-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    if (btn.classList.contains('sold-out')) return;
    document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    selectedVariantId = btn.dataset.variantId;
    document.getElementById('variant-id').value = selectedVariantId;
    document.getElementById('size-error').style.display = 'none';
  });
});

document.getElementById('product-form')?.addEventListener('submit', async (e) => {
  e.preventDefault();
  const hasSizes = document.querySelectorAll('.size-btn').length > 0;
  if (hasSizes && !selectedVariantId) {
    document.getElementById('size-error').style.display = 'block';
    return;
  }
  const btn = document.getElementById('add-to-cart-btn');
  const variantId = document.getElementById('variant-id').value;
  await addToCart(variantId, 1);
  btn.textContent = 'AGREGADO';
  setTimeout(() => { btn.textContent = 'AGREGAR AL CARRITO'; }, 1500);
  openCartDrawer();
});

// Cart page quantity / remove controls (server-rendered cart template).
// Posts to /cart/change.js then reloads so totals re-render.
async function changeCartLine(key, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  window.location.reload();
}
document.querySelectorAll('[data-qty-dec], [data-qty-inc], [data-remove]').forEach(btn => {
  // Skip the drawer's own buttons (those use inline onclick handlers from cart.js).
  if (btn.closest('#cart-drawer')) return;
  btn.addEventListener('click', () => {
    const controls = btn.closest('.cart-item__controls');
    const current = parseInt(controls?.querySelector('.cart-item__qty')?.textContent || '0', 10);
    if (btn.hasAttribute('data-remove')) changeCartLine(btn.getAttribute('data-remove'), 0);
    else if (btn.hasAttribute('data-qty-dec')) changeCartLine(btn.getAttribute('data-qty-dec'), Math.max(0, current - 1));
    else if (btn.hasAttribute('data-qty-inc')) changeCartLine(btn.getAttribute('data-qty-inc'), current + 1);
  });
});

// Newsletter
document.getElementById('newsletter-form')?.addEventListener('submit', (e) => {
  const email = document.getElementById('newsletter-email').value;
  const msg = document.getElementById('newsletter-msg');
  if (!email || !email.includes('@')) {
    e.preventDefault();
    msg.textContent = 'INGRESÁ UN EMAIL VÁLIDO';
    msg.style.color = 'red';
  }
});
